export default __webpack_public_path__ + "static/hero-image-a5c175f9d65e501578fdf5ae193d6154.png";